import clsx from 'clsx'
import React, {type PropsWithChildren} from 'react'

import {classes} from './styles'

type Props = {
  className?: string
}

const Drawer = React.forwardRef<HTMLDivElement, PropsWithChildren<Props>>(({children, className}, ref) => {
  return (
    <div className={clsx(classes.root, className)} ref={ref}>
      {children}
    </div>
  )
})

export default Drawer
